import { RESIZE_URL } from "../constants";

const CDN_BASE_URL = "https://fesmeknes.fra1.cdn.digitaloceanspaces.com/";

const constructImgUrl = (src, width, quality) => {
  const url = new URL(RESIZE_URL);
  url.searchParams.set("url", `${CDN_BASE_URL}${src}`);
  url.searchParams.set("width", width);
  url.searchParams.set("type", "webp");
  url.searchParams.set("quality", quality ?? 75);
  url.searchParams.set("stripmeta", "true"); // Remove EXIF data for smaller file size
  url.searchParams.set("compression", "9"); // Maximum compression
  return url.toString();
};

const ResponsiveImg = ({
  src,
  alt,
  sizes,
  fetchpriority,
  loading = "eager",
}) => {
  const srcSet = `${constructImgUrl(src, 320)} 320w, ${constructImgUrl(
    src,
    480
  )} 480w, ${constructImgUrl(src, 768)} 768w, ${constructImgUrl(
    src,
    1024
  )} 1024w`;

  return (
    <img
      src={constructImgUrl(src, 768)} // Fallback
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      fetchpriority={fetchpriority}
      loading={loading}
      decoding="async"
    />
  );
};

export default ResponsiveImg;
